import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.svg';

const Footer = () => {
  const { t, lang } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative py-8 px-4">
      {/* Animated gradient separator */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent animate-gradient-shift" style={{ backgroundSize: '200% 100%' }} />
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <img src={logo} alt="Tom Art Mask" className="h-12 w-auto" />
        <div className="text-center">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} Tom Art Mask. {t.footer.rights}
          </p>
          <div className="flex items-center gap-3 mt-1">
            <Link to="/privacy" className="text-muted-foreground hover:text-primary text-xs transition-colors">
              {lang === 'cs' ? 'Ochrana osobních údajů' : 'Privacy Policy'}
            </Link>
            <span className="text-muted-foreground/30 text-xs">|</span>
            <Link to="/admin" className="text-muted-foreground/40 hover:text-primary text-xs transition-colors">
              Admin
            </Link>
          </div>
        </div>
        <motion.button
          onClick={scrollToTop}
          animate={{ y: [0, -3, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          className="text-muted-foreground hover:text-primary transition-colors text-sm uppercase tracking-widest"
        >
          ↑ Top
        </motion.button>
      </div>
    </footer>
  );
};

export default Footer;
